import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import '@babel/polyfill'

import VeeValidate from "./plugins/VeeValidate"
import Convert from "./plugins/Convert"
import VueQuillEditor from "./plugins/VueQuillEditor"
import VueGoogleMaps from "./plugins/VueGoogleMaps"
import VueApexCharts from "./plugins/VueApexCharts"
import VueAwesomeSwiper from "./plugins/VueAwesomeSwiper"
import VueSocialSharing from "./plugins/VueSocialSharing"
import VueZoomer from "./plugins/VueZoomer"
import Firebase from "./plugins/Firebase"
import VCurrencyField from "./plugins/VCurrencyField"
import VueHtml2Canvas from "./plugins/VueHtml2Canvas"
import VueReCaptcha from "./plugins/VueReCaptcha"

import GmapVue from "./plugins/GmapVue"

import '@/assets/css/main.css'

import { TokenService } from "@/service/Storage.Service.js"

const safeParseJSON = (value) => {
  if (!value || value === "undefined" || value === "null" || value === "") {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}

if (TokenService.getToken()) {
  store.commit("setToken", TokenService.getToken())
  store.commit("setUser", safeParseJSON(TokenService.getUser()))
  store.commit("setMenu", safeParseJSON(TokenService.getMenu()))
  
  store.commit("setReload", TokenService.getReload())

  store.commit("setCounter", safeParseJSON(TokenService.getCounter()))

  store.commit("setYear", parseInt(TokenService.getYear()))
}

store.commit("setCompany", safeParseJSON(TokenService.getCompany()))
store.commit("setColor", TokenService.getColor())
store.commit("setDpa", safeParseJSON(TokenService.getDpa()))

store.commit("setFcm", TokenService.getFcm())

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueGoogleMaps,
  VueApexCharts,
  VueAwesomeSwiper,
  VueSocialSharing,
  VueZoomer,
  Firebase,
  VCurrencyField,
  VueHtml2Canvas,
  GmapVue,
  VueReCaptcha,
  render: h => h(App)
}).$mount('#app')
